import { combineReducers } from "redux";
import { reducer as reduxAsyncConnect } from "redux-connect";
import auth from "./auth";
import { sliderReducer as slider } from "../../modules/Slider";
import { companyReducer as company } from "../../modules/Company";
import { workerReducer as worker } from "../../modules/Worker";
import { staticPageReducer as staticPage } from "../../modules/Static";
import { newsReducer as news } from "../../modules/News";
import { deviceReducer as device } from "../../modules/Device";
import { modemReducer as modem } from "../../modules/Modem";
import { taskReducer as task } from "../../modules/Task";
import { searchReducer as search } from "../../modules/Search";

import { trainingReducer as training } from "../../modules/Training";
import { cardReducer as card } from "../../modules/Product";
import { keyReducer as key } from "../../modules/Product";
import { debitorMappingReducer as debitorMapping } from "../../modules/DebitorMapping";
import { permissionsReducer as permissions } from "../../modules/Permissions";
import { ngumReducer as ngum } from "../../modules/NGum";

export default (router) =>
  combineReducers({
    router,
    reduxAsyncConnect,
    auth,
    slider,
    company,
    worker,
    staticPage,
    news,
    device,
    modem,
    card,
    key,
    task,
    search,
    // report,
    // salesForm,
    training,
    // salesProduct,
    debitorMapping,
    permissions,
    ngum,
  });
